module.exports = __webpack_public_path__ + "static/media/1024_logo_center.9751a915.png";